import React from 'react';
import { theme } from '../styles/theme';
import Container from '../components/ui/Container';
import FooterPageContent from '../components/layout/FooterPageContent';

const ContactPage = () => {
  const pageStyles = {
    padding: `${theme.spacing.xxl} 0`,
    backgroundColor: theme.colors.background,
    minHeight: '100vh',
  };

  const contentStyles = {
    maxWidth: '900px',
    margin: '0 auto',
    padding: `0 ${theme.spacing.lg}`,
  };

  const headingStyles = {
    fontFamily: theme.typography.fontFamily.primary,
    fontSize: theme.typography.fontSize.xxl,
    fontWeight: theme.typography.fontWeight.bold,
    color: theme.colors.primary,
    marginBottom: theme.spacing.lg,
    textAlign: 'center',
  };

  const subHeadingStyles = {
    fontFamily: theme.typography.fontFamily.primary,
    fontSize: theme.typography.fontSize.xl,
    fontWeight: theme.typography.fontWeight.semibold,
    color: theme.colors.primaryDark,
    marginTop: theme.spacing.xl,
    marginBottom: theme.spacing.md,
  };

  const paragraphStyles = {
    fontSize: theme.typography.fontSize.base,
    lineHeight: theme.typography.lineHeight.relaxed,
    color: theme.colors.text,
    marginBottom: theme.spacing.md,
  };

  const contactBoxStyles = {
    backgroundColor: theme.colors.neutral,
    padding: theme.spacing.lg,
    borderRadius: theme.borderRadius.md,
    marginTop: theme.spacing.lg,
    marginBottom: theme.spacing.lg,
  };

  const infoBoxStyles = {
    backgroundColor: theme.colors.primaryLight,
    padding: theme.spacing.md,
    borderRadius: theme.borderRadius.md,
    marginBottom: theme.spacing.lg,
    borderLeft: `4px solid ${theme.colors.primary}`,
  };

  return (
    <FooterPageContent slug="contact">
    <div style={pageStyles}>
      <Container>
        <div style={contentStyles}>
          <h1 style={headingStyles}>Contact BS Trading Co.</h1>

          <p style={paragraphStyles}>
            We're here to help! Whether you have questions about our products, need assistance with 
            an order, or want to discuss wholesale opportunities, our team is ready to assist you.
          </p>

          <div style={contactBoxStyles}>
            <h2 style={{ ...subHeadingStyles, marginTop: 0 }}>Get in Touch</h2>
            
            <p style={{ ...paragraphStyles, marginBottom: theme.spacing.xs }}>
              <strong>BS Trading Co.</strong>
            </p>
            <p style={{ ...paragraphStyles, marginBottom: theme.spacing.xs }}>253 Loy St</p>
            <p style={{ ...paragraphStyles, marginBottom: theme.spacing.lg }}>Burleson, TX 76028</p>

            <p style={{ ...paragraphStyles, marginBottom: theme.spacing.xs }}>
              <strong>Phone:</strong> <a href="tel:8174474433" style={{ color: theme.colors.primary }}>817-447-4433</a>
            </p>
            <p style={{ ...paragraphStyles, marginBottom: theme.spacing.lg }}>
              <strong>Toll-Free:</strong> <a href="tel:18005540910" style={{ color: theme.colors.primary }}>1-800-554-0910</a>
            </p>

            <p style={{ ...paragraphStyles, marginBottom: 0 }}>
              <strong>Email:</strong> <a href="mailto:Orders@BSTrading.com" style={{ color: theme.colors.primary }}>Orders@BSTrading.com</a>
            </p>
          </div>

          <h2 style={subHeadingStyles}>Business Hours</h2>
          <div style={infoBoxStyles}>
            <p style={{ ...paragraphStyles, marginBottom: theme.spacing.xs }}>
              <strong>Monday - Friday:</strong> 8:00 AM - 5:00 PM CST
            </p>
            <p style={{ ...paragraphStyles, marginBottom: 0 }}>
              <strong>Saturday - Sunday:</strong> Closed
            </p>
          </div>

          <h2 style={subHeadingStyles}>How Can We Help?</h2>
          <p style={paragraphStyles}>
            Our knowledgeable staff is available to assist with:
          </p>
          <ul style={{
            fontSize: theme.typography.fontSize.base,
            lineHeight: theme.typography.lineHeight.relaxed,
            color: theme.colors.text,
            marginBottom: theme.spacing.md,
            paddingLeft: theme.spacing.xl,
          }}>
            <li>Product inquiries and recommendations</li>
            <li>Order status and tracking</li>
            <li>Wholesale and bulk order pricing</li>
            <li>Custom orders and special requests</li>
            <li>Shipping and delivery questions</li>
            <li>Returns and exchanges</li>
            <li>General customer service</li>
          </ul>

          <h2 style={subHeadingStyles}>Visit Our Location</h2>
          <p style={paragraphStyles}>
            We welcome visitors to our facility in Burleson, Texas! Come see our extensive inventory 
            in person and experience the quality of our products firsthand. Our staff will be happy 
            to show you around and answer any questions you may have.
          </p>

          <div style={infoBoxStyles}>
            <p style={{ ...paragraphStyles, marginBottom: 0 }}>
              <strong>Note:</strong> For large orders or special appointments, we recommend calling 
              ahead to ensure we can give you our full attention.
            </p>
          </div>

          <h2 style={subHeadingStyles}>Response Time</h2>
          <p style={paragraphStyles}>
            We strive to respond to all inquiries within one business day. During peak seasons, 
            response times may be slightly longer, but we'll get back to you as quickly as possible.
          </p>

          <p style={paragraphStyles}>
            Thank you for your interest in BS Trading Co. We look forward to hearing from you!
          </p>
        </div>
      </Container>
    </div>
    </FooterPageContent>
  );
};

export default ContactPage;

